/**
 * Handles Knockout promo
 * Call onEnteredTo, when in a room, and onShowEnded when the show stops
 */
import {Application} from "../application/application";
import webAPI from "../api/web-api-2";
import {JoinedRoomData} from "../chatserver/sx-server";

export class Knockout
{
	roomID: string;
	checkWaitTimer: number;
	/** Keeps data of the current promo */
	private promo: any;
	private screenName: string;

	constructor(private app : Application)
	{

	}

	/**
	 * Returns with a promise that resolves to the current promo (if any)
	 */
	private getCurrentPromo()
	{
		const m = new Date().getMinutes();

		if (this.promo && (this.promo.startmin < m && m < this.promo.endmin))
		{
			return Promise.resolve(this.promo);
		}
		else
		{
			return webAPI.get("member/knockOutPromo/getCurrent", {})
				.then((r : any) => {
						if (r.success) {
							this.promo = r.promo;
							return this.promo;
						} else {
							return Promise.reject(null);
						}
					}
				);
		}
	}

	async onEnteredTo(room : JoinedRoomData)
	{
		const hasToys = room.publicData.toys && !!room.publicData.toys.default;

		if (!hasToys) {
			return;
		}

		this.roomID = room.roomid;
		this.screenName = room.screenName;

		// We wait a random amount of time to avoid throwing the
		// notification right at the beginning of the show

		clearTimeout(this.checkWaitTimer);

		this.checkWaitTimer = setTimeout(async () =>
		{
			const promo = await this.getCurrentPromo();

			if (promo) {
				this.showPromo();
				this.setOffered();
			} else {
				this.hidePromo();
			}

		}, 30000 + Math.random() * 60000)
	}

	onShowEnded()
	{
		clearTimeout(this.checkWaitTimer);
		this.hidePromo();
	}

	private showPromo()
	{
		const title = this.app.translator.t("promo_notification_knockout_title");
		const link = this.app.translator.t("promo_notification_knockout_link");
		const desc = this.app.translator.t("promo_notification_knockout_desc")
			.replace("{{s}}", "<span class='sxcc-strikethrough'>")
			.replace("{{/s}}", "</span>")
			.replace("{{original_price}}", "5000")
			.replace("{{price}}", "1500")
			.replace("{{name}}", this.screenName);

		const $notif = $("<div />")
			.append(
				$("<div class='sxccsn-title' />").text(title),
				$("<p />")
					.append(desc)
					.append(" ")
					.append($("<a href='#' />").text(link))
			);

		this.app.view.streamNotificationManager.add(
			$notif,
			"big",
			"knockout-promo",
			null,
			() => {
				this.app.view.giftPanel.showGift("ohmibod_knockout");
			});
	}

	private hidePromo()
	{
		this.promo = null;
		this.app.view.streamNotificationManager.clearByTag("knockout-promo")
	}

	// noinspection JSMethodCanBeStatic
	private setOffered()
	{
		webAPI.post("member/knockOutPromo/setOffered", {})
	}
}
